import { api } from "@/lib/api";

const ID_KEY = "wm_device";
const OPEN_KEY = "wm_app_open";

export const isStandalone = () => window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;
export const isIOS = () => /iphone|ipad|ipod/i.test(navigator.userAgent) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
export const platform = () => (isIOS() ? "ios" : /android/i.test(navigator.userAgent) ? "android" : "desktop");

const deviceId = () => {
  let id = localStorage.getItem(ID_KEY);
  if (!id) { id = crypto.randomUUID(); localStorage.setItem(ID_KEY, id); }
  return id;
};

export const track = (event) => api.post("/app/event", { device_id: deviceId(), event, platform: platform() }).catch(() => {});

export const trackOpen = () => {
  const today = new Date().toISOString().slice(0, 10);
  if (!isStandalone() || localStorage.getItem(OPEN_KEY) === today) return;
  localStorage.setItem(OPEN_KEY, today);
  track("open");
};

export const registerSW = () => {
  if ("serviceWorker" in navigator) navigator.serviceWorker.register("/sw.js").catch(() => {});
};
